'use client'

import {
    HOME_STYLE,
    STATS,
    SERVICES,
    SLIDESHOW,
    ABOUT_BANNER,
    TEAM_MEMBERS,
    PROJECTS,
} 
from "./actions";
import axios from 'axios'
const reducer = (state, action) => {
    
    if (action.type === HOME_STYLE){
        return {
            ...state,
            header_color: action.payload.headerColor,
            header_text_color: action.payload.headerTextColor,
            footer_color: action.payload.footerColor,
            footer_text_color: action.payload.footerTextColor,
            logo: action.payload.logo,
            monogram: action.payload.monogram,
        }
    }
    if (action.type === STATS){
        return {
            ...state,
            happy_clients: action.payload.happyClients,
            no_of_projects_done: action.payload.projectsDone,
            team_members: action.payload.teamMembers,
        }
    }
    if (action.type === SERVICES){
        return {
            ...state,
            services: action.payload.services
        }
    }
    if (action.type === SLIDESHOW){
        return {
            ...state,
            slideshow_images: action.payload.slideshowImages
        }
    }
    




    if (action.type === ABOUT_BANNER){
        return {
            ...state,
            about_page_image_url: action.payload.mainImage,
            about_page_main_text: action.payload.mainText,
        }
    }
    if (action.type === TEAM_MEMBERS){
        return {
            ...state,
            team_members: action.payload.teamMembers,
        }
    }




    throw new Error(`no such action: ${action.type}`)
}

export default reducer